import { Form } from 'antd'

import type { FormInstance } from 'antd'
import type { MusicGeneratorFormValuesNew } from '@/pages/tad.ai/ai-music-generator/_types/form'

import { useAiMusicGeneratorStoreFromZustand } from '@/pages/tad.ai/ai-music-generator/_store/createStore'


import { useMemo } from 'react';
interface IProps {
  form: FormInstance<MusicGeneratorFormValuesNew>
}

export default function useGetFormKeyPrefix(props: IProps) {
  const { form } = props
  const promptTabsMode = Form.useWatch(['promptTabsMode'], form) || 'smart'
  const customTaskType = Form.useWatch(['customTaskType'], form)
  const { finalTaskType } = useAiMusicGeneratorStoreFromZustand()

  const taskType = useMemo(() => {
    if (promptTabsMode === 'smart') {
      return finalTaskType
    } else {
      return customTaskType
    }
  }, [customTaskType, promptTabsMode, finalTaskType])

  //smart下song和instrumental切换时会重新生成style组件，可共享相同的formKey
  //custom下为tab切换，需设置不同的formKey以保存状态
  const formKeyPrefix = promptTabsMode === 'smart' ? '' : taskType
  return formKeyPrefix
}
